<ng-template #buttonContent>
  @if (icon()) {
    <span
      [class.mr-0]="square()"
      [class]="iconClasses()"></span>
  }
  <ng-content />
</ng-template>

<button
  [attr.aria-disabled]="disabledOrLoading()"
  [attr.id]="id()"
  [disabled]="disabled() || loading()"
  [ngClass]="buttonClasses()"
  [type]="buttonType()"
  (click)="handleClick($event)">
  <ng-container [ngTemplateOutlet]="buttonContent" />
</button>
